import { setAddressBook } from './addressBook';
import { setFormModalVisible } from './form';
import { setNoticeModalVisible } from './notice';
import { setProfileVisible } from './profile';
import { setTaskModalVisible } from './task';
import { setScoreVisible } from './score';
import store from "store";

export const closeAllModal = () => {
    const dispatch = store.dispatch;
    // 关闭分配导师弹窗
    dispatch(setAddressBook({
        visible: false
    }))
    // form 表单
    setFormModalVisible(false)
    // 消息列表
    setNoticeModalVisible(false)
    // 个人资料
    setProfileVisible(false)
    // 待办
    setTaskModalVisible(false)
    // 评分组件
    setScoreVisible(false)
};

